import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface UserSubscriptionObject {
  id: number;
  titleEn: string;
  titleAr: string;
  descriptionEn: string;
  descriptionAr: string;
  slug: string;
  isActive: boolean;
  price: number;
  sort: number;
  type: number;
  validity: number;
  color: string;
}

export interface UserSubscriptionListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  userSubscription: Array<UserSubscriptionObject>;
  errors: unknown;
}
@Module
export default class UserSubscriptionModule
  extends VuexModule
  implements UserSubscriptionListInfo
{
  userSubscription = [] as Array<UserSubscriptionObject>;

  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  /**
   * Get Ads list
   * @returns Array<AdsObject>
   */
  get usersubscriptionsList(): Array<UserSubscriptionObject> {
    return this.userSubscription;
  }

  /**
   * Get total items
   * @returns number
   */
  get usersubscriptionsListCount(): number {
    return this.totalItems;
  }

  @Mutation
  [Mutations.SET_USERS_SUBSCRIPTIONS](data) {
    this.userSubscription = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_USERS_SUBSCRIPTIONS_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.RESET_USERS_SUBSCRIPTION_LIST]() {
    this.userSubscription = [] as Array<UserSubscriptionObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Action
  [Actions.RESET_USERS_SUBSCRIPTION_STORE]() {
    this.context.commit(Mutations.RESET_USERS_SUBSCRIPTION_LIST);
  }

  @Action
  [Actions.UPDATE_USERS_SUBSCRIPTIONS_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_USERS_SUBSCRIPTIONS_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_USERS_SUBSCRIPTIONS]() {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/subscriptions/users-subscriptions', {
      params: { page: this.currentPage },
    })
      .then(({ data }) => {
        data.data = data.data.map((r) => {
          r.endDate = new Date(r.endDate).toLocaleString('en-GB').split(',')[0];
          return r;
        });
        this.context.commit(Mutations.SET_USERS_SUBSCRIPTIONS, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }
}
